export function InitBrowserAgent() {
    // get browser name
    const browser = (function () {
        const test = function (regexp) { return regexp.test(window.navigator.userAgent) };
        switch (true) {
            case test(/edg/i): return "Microsoft Edge";
            case test(/trident/i): return "Microsoft Internet Explorer";
            case test(/firefox|fxios/i): return "Mozilla Firefox";
            case test(/opr\//i): return "Opera";
            case test(/ucbrowser/i): return "UC Browser";
            case test(/samsungbrowser/i): return "Samsung Browser";
            case test(/chrome|chromium|crios/i): return "Google Chrome";
            case test(/safari/i): return "Apple Safari";
            default: return "Other";
        }
    })();

    // get language
    const language = navigator.language;
    // get platform
    const platform = navigator.platform;

    // get access url
    const URL = document.URL;

    // get innerWidth
    const innerWidth = window.innerWidth;

    //get innerHeight
    const innerHeight = window.innerHeight;

    const outerWidth = window.outerWidth;
    const outerHeight = window.outerHeight;

    // generate random number and split it
    const randomNumber = Math.random().toString().split('.');
    // pick up first index from randomNumber array
    // const visitor_generated__id = randomNumber[1];

    // get old visitor id
    const visitor_generated__id = localStorage.getItem('visitor_id');

    /*
    * is exist old visitor id
    * if old visitor id does not exist add id to localStorage
    */
    let is_new_visitor = 'no';
    if (visitor_generated__id === null) {
        localStorage.setItem('visitor_id', randomNumber[1]);
        is_new_visitor = 'yes';
        //console.log('added to localStorage id with key visitor_id');
    } else {
        is_new_visitor = 'no';
        // console.log(get_visitor_generated__id);
    }
    const referrer =  document.referrer;

    return {
        browser, language, platform, innerWidth, innerHeight, URL, visitor_generated__id, is_new_visitor,outerWidth,outerHeight,referrer
    }
}




